module.exports = __webpack_public_path__ + "static/media/reset-zoom.c1c97c01.svg";